import React from 'react';
import DesktopAdhesionFs from './freestar/Adhesion';
const DesktopAdhesion = ({ safety = 'off', safetyState })=>{
    return /*#__PURE__*/ React.createElement(DesktopAdhesionFs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
